define(['components/utilities/utilities', 'components/loader/loader', 'libs/nanoajax'], function (utils, loader, nanoajax) {
	'use strict';

	/**
	 * Load content
	 * A plugin that loads content into a DOM node.
	 * @exports loadContent
	 */
	var loadContent = {

		/**
		 * The initialization function for this module.
		 * @param {Object} els - An array of DOM nodes.
		 * @public
		 */
		init: function (els) {
			for (var i = 0; i < els.length; i++) {
				this._initEvents(els[i]);
			}
		},


		/**
		 * Function that displays the ajax-loaded content (if it has been loded, else it calls _loadContent)
		 * @param {Object} el - The trigger link as a DOM node.
		 * @param {Object} target - A DOM node into where the loaded content should be rendered.
		 * @see {@link module:loadContent._loadContent}
		 * @private
		 */
		_viewContent: function (el, target) {
			el.setAttribute('aria-expanded', true);
			target.setAttribute('aria-hidden', false);

			if (target.getAttribute('tabindex') === null) {
				target.setAttribute('tabindex', '-1');
			}
			target.focus();

			if (el.getAttribute('data-content') === null) {
				this._loadContent(el, target);
				return false;
			}

			target.innerHTML = el.getAttribute('data-content');
		},


		/**
		 * Loads content with ajax, then calls _viewContent to render it.
		 * @param {Object} el - The trigger link as a DOM node.
		 * @param {Object} target - A DOM node into where the loaded content should be rendered.
		 * @see {@link module:loadContent._viewContent}
		 * @private
		 */
		_loadContent: function (el, target) {
			var that = this,
				url = el.getAttribute('data-url'),
				loadingMessage = el.getAttribute('data-loading-message');

			if (loadingMessage === null) {
				loadingMessage = 'Loading new content...';
			}

			loader.loadingStart(target, loadingMessage, 'large');

			nanoajax.ajax({
				method: 'GET',
				url: url
			},
			function (code, responseText) {
				if (code === 200) {
					el.setAttribute('data-content', responseText);
					that.requestInProgress = false;
					that._viewContent(el, target);
				}
			});
		},


		/**
		 * Close the content.
		 * @param {Object} el - The trigger link as a DOM node.
		 * @param {Object} target - A DOM node into where the loaded content has been rendered.
		 * @private
		 */
		_closeContent: function (el, target) {
			target.innerHTML = '';

			el.setAttribute('aria-expanded', false);
			target.setAttribute('aria-hidden', true);
			el.focus();
		},


		/**
		 * Closes other open links in the same group.
		 * @param {Object} el - The trigger link as a DOM node.
		 * @private
		 */
		_closeActiveLinks: function (el) {
			utils.forEachElement('[data-type="loadContent"][data-target="' + el.getAttribute('data-target') + '"]', function (link) {
				link.setAttribute('aria-expanded', false);
			});
		},


		/**
		 * Init click events.
		 * @param {Object} el - The trigger link as a DOM node.
		 * @private
		 */
		_initEvents: function (el) {
			var that = this;

			utils.addEventListener(el, 'click', function (event) {
				if (event.preventDefault) { event.preventDefault(); } else { event.returnValue = false; }
				var target = document.getElementById(el.getAttribute('data-target'));

				if (target === null) {
					return false;
				}

				if (el.getAttribute('aria-expanded') === 'true') {
					that._closeContent(el, target);
				} else {
					that._closeActiveLinks(el);
					that._viewContent(el, target);
				}
			});
		}
	};


	return loadContent;
});


//////////////////
// WEBPACK FOOTER
// ./components/loadContent/loadContent.js
// module id = 60
// module chunks = 13